import { Box, Tooltip, Chip, Typography } from "@mui/joy";
import { Info as InfoIcon } from "lucide-react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

import { IconButton } from "../../../../shared";
import { ROLE_LABELS, ROLES } from "../../../../constants/permissions";

export function Info(props: any) {
    const navigate = useNavigate();
    const { value } = props;

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Tooltip title="Edit admin" placement="top">
                <IconButton
                    size="sm"
                    variant="soft"
                    color="primary"
                    onClick={() => navigate(`/admin/tenant/admins/edit/${value}`)}
                    sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        "--IconButton-size": "32px",
                        borderRadius: "4px",
                    }}
                >
                    <InfoIcon size={16} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}

export function StatusCellRenderer(props: any) {
    const isActive = props.value === true || props.value === 1 || props.value === "1";
    return (
        <Box display="flex" alignItems="center" height="100%">
            <Chip
                variant="soft"
                color={isActive ? "success" : "neutral"}
                size="md"
                sx={{ borderRadius: "4px", border: "1px solid", borderColor: "divider" }}
            >
                {isActive ? "Active" : "Inactive"}
            </Chip>
        </Box>
    );
}

export function OrganizationCountCellRenderer(props: any) {
    const count = Number(props.value ?? 0);
    const label = count === 1 ? "1 org" : `${count} orgs`;

    return (
        <Box display="flex" alignItems="center" height="100%">
            <Chip
                size="sm"
                variant="soft"
                color={count > 0 ? "primary" : "neutral"}
                sx={{ borderRadius: "4px" }}
            >
                {label}
            </Chip>
        </Box>
    );
}

export function RolesCellRenderer(props: any) {
    const roleNames = (props.value as string) || ROLE_LABELS[ROLES.SUPER_ADMIN];
    return (
        <Box display="flex" alignItems="center" gap={0.5} height="100%" flexWrap="wrap" py={0.5}>
            {roleNames.split(",").map((name) => (
                <Chip
                    key={name.trim()}
                    size="sm"
                    variant="soft"
                    color="primary"
                    sx={{ borderRadius: "4px" }}
                >
                    {name.trim()}
                </Chip>
            ))}
        </Box>
    );
}

/** e.g. 2 May 2026, 10:00AM */
export function CreatedAtCellRenderer(props: any) {
    if (!props.value) {
        return null;
    }

    return (
        <Box display="flex" alignItems="center" height="100%">
            <Typography level="body-sm">
                {moment(props.value).format("D MMM YYYY, h:mmA")}
            </Typography>
        </Box>
    );
}
